import { useQuery, UseQueryResult } from 'react-query';
import { getTiledeskConfig } from './api';
import { ITiledeskConfig } from './types';

export enum TiledeskHooks {
  Config = 'tiledeskConfig',
}

export function useTiledeskConfig(enabled: boolean): UseQueryResult<ITiledeskConfig> {
  return useQuery([TiledeskHooks.Config], () => getTiledeskConfig(), {
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
